/**
 * Mobile Portal Settings – field op account
 */

import { User, Bell, Shield, Monitor } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const settingSections: { title: string; items: { icon: React.ElementType; label: string; description: string; value?: string }[] }[] = [
  {
    title: 'Account',
    items: [
      { icon: User, label: 'Profile', description: 'Field op profile', value: 'Demo Field Op' },
      { icon: Shield, label: 'Security', description: 'Password and 2FA' },
    ],
  },
  {
    title: 'Preferences',
    items: [
      { icon: Bell, label: 'Notifications', description: 'Alerts for units and ATMs', value: 'Enabled' },
      { icon: Monitor, label: 'Appearance', description: 'Theme', value: 'System' },
    ],
  },
];

export default function Settings() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">Manage your field ops account</p>
      </div>

      {settingSections.map((section) => (
        <div key={section.title} className="rounded-xl border bg-card p-6">
          <h2 className="font-semibold mb-4">{section.title}</h2>
          <div className="space-y-3">
            {section.items.map((item) => (
              <div key={item.label} className="flex items-center justify-between py-3 border-b border-border last:border-0">
                <div className="flex items-center gap-3">
                  <item.icon className="h-5 w-5 text-muted-foreground" />
                  <div>
                    <p className="font-medium text-sm">{item.label}</p>
                    <p className="text-xs text-muted-foreground">{item.description}</p>
                  </div>
                </div>
                {item.value && <p className="text-sm text-muted-foreground">{item.value}</p>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
